import Load from 'components/Load';
import React from 'react';
import { Route } from 'react-router-dom';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';

export interface PersonalizedOfferRoutesParams {
  id: string;
}

const AsyncCreatePoContainer = Load(
  () => import(/* webpackChunkName: "host-po" */ './CreatePoContainer'),
  {},
  true,
);
const AsyncNewPoContainer = Load(
  () => import(/* webpackChunkName: "host-po" */ './NewPoContainer'),
  {},
  true,
);
const AsyncUpdatePoContainer = Load(
  () => import(/* webpackChunkName: "host-po" */ './UpdatePoContainer'),
  {},
  true,
);

export const hostPersonalizedOfferNewRoute: RouteDescriptor = {
  id: 'host.personalized-offer.new',
  path: `${basePath}/new-personalized-offer/:id/*`,
  label: 'New Personalized Offer',
  audience: 'host',
  layout: 'standalone',
  module: 'host-personalized-offer',
};

export const hostPersonalizedOfferCreateRoute: RouteDescriptor = {
  id: 'host.personalized-offer.create',
  path: `${basePath}/create-personalized-offer/:id/*`,
  label: 'Create Personalized Offer',
  audience: 'host',
  layout: 'standalone',
  module: 'host-personalized-offer',
};

export const hostPersonalizedOfferUpdateRoute: RouteDescriptor = {
  id: 'host.personalized-offer.update',
  path: `${basePath}/update-personalized-offer/:id/*`,
  label: 'Update Personalized Offer',
  audience: 'host',
  layout: 'standalone',
  module: 'host-personalized-offer',
};

export const hostPersonalizedOfferRoutes = [
  <Route
    key={hostPersonalizedOfferNewRoute.id}
    id={hostPersonalizedOfferNewRoute.id}
    path={hostPersonalizedOfferNewRoute.path}
    handle={createRouteHandle(hostPersonalizedOfferNewRoute)}
    element={<AsyncNewPoContainer />}
  />,
  <Route
    key={hostPersonalizedOfferCreateRoute.id}
    id={hostPersonalizedOfferCreateRoute.id}
    path={hostPersonalizedOfferCreateRoute.path}
    handle={createRouteHandle(hostPersonalizedOfferCreateRoute)}
    element={<AsyncCreatePoContainer />}
  />,
  <Route
    key={hostPersonalizedOfferUpdateRoute.id}
    id={hostPersonalizedOfferUpdateRoute.id}
    path={hostPersonalizedOfferUpdateRoute.path}
    handle={createRouteHandle(hostPersonalizedOfferUpdateRoute)}
    element={<AsyncUpdatePoContainer />}
  />,
];

export const hostPersonalizedOfferRouteDescriptors = [
  hostPersonalizedOfferNewRoute,
  hostPersonalizedOfferCreateRoute,
  hostPersonalizedOfferUpdateRoute,
];

export default hostPersonalizedOfferRoutes;
